import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { SearchState } from '@features/search/services/search.state';
import { SearchClientForm } from 'app/shared/models/ClientData';

@Injectable({ providedIn: 'root' })
export class AppBootstrapService {
  constructor(private readonly searchState: SearchState) {}

  bootstrapFromUrl(ctx: { tenantId?: string|null; searchValue?: string|null; dateRange?: string|null; currentPage?: string|null }) {
    const { tenantId, searchValue, dateRange, currentPage } = ctx;
    if (!tenantId || !searchValue || !dateRange || !currentPage) return;

    const tenant = environment.tenants.find(t => t.tenantId.toUpperCase() === tenantId.toUpperCase());
    if (!tenant) return;

    const form: SearchClientForm = { searchValue, dateRange, tenant, currentPage };
    this.searchState.updateSearchForm(form);
  }
}
